import React from 'react'
import { LegacyPerformanceData, PerformanceData } from '../../../../types/api'
import { Table, TableHeading, TableCell } from '../../../atoms/Table'
import { EmptyCard } from '../../../common/EmptyCard'
import { Help } from '../../../common/Help'
import { formatWithComma } from '@/lib/number'
import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'
import { LimitedToEnterpriseContents } from '../../../common/LimitedToEnterpriseContents'

type Props = {
  performances: PerformanceData[]
  legacyPerformances: LegacyPerformanceData[]
  isEnterprise: boolean
}

export const PerformancesTable: React.FC<Props> = (props) => {
  if (!props.isEnterprise) {
    return (
      <Table>
        <thead
          css={css`
            ${mq.untilMedium} {
              display: ${props.isEnterprise ? 'initial' : 'none'};
            }
          `}
        >
          <tr>
            <TableHeading>期</TableHeading>
            <TableHeading>年</TableHeading>
            <TableHeading>月</TableHeading>
            <TableHeading>
              区分
              <Help>連結か単体かを示す</Help>
            </TableHeading>
            <TableHeading sub="千円">売上</TableHeading>
            <TableHeading sub="千円">営業利益 </TableHeading>
            <TableHeading sub="千円">経常利益</TableHeading>
            <TableHeading sub="千円">当期利益</TableHeading>
            <TableHeading>出所</TableHeading>
            <TableHeading>備考</TableHeading>
          </tr>
        </thead>
        <tbody
          css={css`
            ${mq.untilMedium} {
              display: flex;
              justify-content: center;
            }
          `}
        >
          <tr>
            <TableCell align="center" colSpan={10}>
              <LimitedToEnterpriseContents />
            </TableCell>
          </tr>
        </tbody>
      </Table>
    )
  }

  if (
    props.performances.length === 0 &&
    props.legacyPerformances.length === 0
  ) {
    return <EmptyCard />
  }

  if (props.performances.length > 0) {
    return (
      <Table>
        <thead>
          <tr>
            <TableHeading>期</TableHeading>
            <TableHeading>年</TableHeading>
            <TableHeading>月</TableHeading>
            <TableHeading>
              区分
              <Help>連結か単体かを示す</Help>
            </TableHeading>
            <TableHeading sub="千円">売上</TableHeading>
            <TableHeading sub="千円">営業利益 </TableHeading>
            <TableHeading sub="千円">経常利益</TableHeading>
            <TableHeading sub="千円">当期利益</TableHeading>
            <TableHeading>出所</TableHeading>
            <TableHeading>備考</TableHeading>
          </tr>
        </thead>
        <tbody>
          {props.performances.map((p, i) => (
            <tr
              key={i}
              css={css`
                td {
                  color: ${p.estimated
                    ? colors.gray70
                    : colors.black30} !important;
                }
              `}
            >
              <TableCell>{p.period}</TableCell>
              <TableCell>{p.year}</TableCell>
              <TableCell>{p.month}</TableCell>
              <TableCell>{p.reportType}</TableCell>
              <TableCell>{formatWithComma(p.sales)}</TableCell>
              <TableCell>{formatWithComma(p.operatingProfit)}</TableCell>
              <TableCell>{formatWithComma(p.ordinaryProfit)}</TableCell>
              <TableCell>{formatWithComma(p.netIncome)}</TableCell>
              <TableCell>{p.sourceType}</TableCell>
              <TableCell>{p.remarks}</TableCell>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>期</TableHeading>
          <TableHeading>年</TableHeading>
          <TableHeading>月</TableHeading>
          <TableHeading>
            区分
            <Help>連結か単体かを示す</Help>
          </TableHeading>
          <TableHeading sub="千円">売上</TableHeading>
          <TableHeading sub="千円">経常利益 </TableHeading>
          <TableHeading sub="千円">当期利益</TableHeading>
          <TableHeading>備考</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.legacyPerformances.map((p, i) => (
          <tr
            key={i}
            css={css`
              td {
                color: ${p.estimated
                  ? colors.gray70
                  : colors.black30} !important;
              }
            `}
          >
            <TableCell>{p.period}</TableCell>
            <TableCell>{p.year}</TableCell>
            <TableCell>{p.month}</TableCell>
            <TableCell>{p.reportType}</TableCell>
            <TableCell>{formatWithComma(p.sales)}</TableCell>
            <TableCell>{formatWithComma(p.ordinaryProfit)}</TableCell>
            <TableCell>{formatWithComma(p.netIncome)}</TableCell>
            <TableCell>{p.remarks}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
